module.exports = __webpack_public_path__ + "static/media/Menu.616a915f.svg";